'use client'

import React, { useState } from 'react'
import { useServerInsertedHTML } from 'next/navigation'
import { ServerStyleSheet, StyleSheetManager } from 'styled-components'

export default function StyledComponentsRegistry({ children }: { children: React.ReactNode }) {
  // Only create stylesheet once with lazy initial state
  // x-ref: https://reactjs.org/docs/hooks-reference.html#lazy-initial-state
  const [styledComponentsStyleSheet] = useState(() => new ServerStyleSheet())

  useServerInsertedHTML(() => {
    const styles = styledComponentsStyleSheet.getStyleElement()
    styledComponentsStyleSheet.instance.clearTag()
    return <>{styles}</>
  })

  const hiddenStyledProps = [
    'xs',
    'sm',
    'md',
    'lg',
    'xl',
    'xxl',
  ]

  return (
    <StyleSheetManager
      sheet={typeof window !== 'undefined' ? undefined : styledComponentsStyleSheet.instance}
      shouldForwardProp={(prop) => !hiddenStyledProps.includes(prop)}
    >
      {children}
    </StyleSheetManager>
  )
}
